const disableDates = {
  pastDatesAndDatesAfterProjDeadline(self: Record<string, any>): void {
    if (!self.assessmentId || !self.projectDeadline || !self.calendarExists) return;

    const year = (document.querySelector('#sweetCalendar .month') as HTMLElement).innerText
      .split(' ')
      .reverse()
      .join('')
      .slice(0, 4);

    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const monthShortcut = (document.querySelector('#sweetCalendar .month') as HTMLElement).innerText
      .split(' ')[0]
      .slice(0, 3);
    const month = months.indexOf(monthShortcut) + 1;

    const yesterday = self.yesterday;

    const allDaysElements = document.querySelectorAll('#sweetCalendar .day');

    allDaysElements.forEach((dayEl: HTMLElement) => {
      const day = parseInt(dayEl.querySelector('span').innerText);
      const projDed = self.getDateWithRequiredFormat(self.projectDeadline);
      let blockDate;

      const pastDate =
        (day <= +yesterday.split('-')[2] &&
          !(+month > +yesterday.split('-')[1]) &&
          !(+year > +yesterday.split('-')[0])) ||
        (month < +yesterday.split('-')[1] && year <= yesterday.split('-')[0]);

      const datePastDeadline =
        (day > projDed.split('-')[2] &&
          month >= projDed.split('-')[1] &&
          year >= projDed.split('-')[0]) ||
        (month > projDed.split('-')[1] && year >= projDed.split('-')[0]) ||
        year > projDed.split('-')[0];

      self.pureCalendar && !self.isInModal
        ? (blockDate = pastDate)
        : (blockDate = pastDate || datePastDeadline);

      dayEl.style.pointerEvents = blockDate ? 'none' : 'auto';

      if (blockDate) dayEl.style.backgroundColor = '#e4ece7';
    });
  },
};

export default disableDates;
